export default __webpack_public_path__ + "static/c7dcb253-8dca-459b-aaa9-afef9131ef22-1521a76d8ceb4cd102a80b5a5abc54a6.woff2";